import React, { ReactNode } from "react";
import styled from "@emotion/styled";

import UIcon, { IconProps } from "../../../lib/icons/untitled_ui/UIcon";
import { Flex, Spacer } from "../../../styles/utility-components";

export type StepItem = {
  icon: IconProps["icon"];
  iconProps?: Omit<IconProps, "icon">;
  title: ReactNode;
  content?: ReactNode;
};

type StepsProps = {
  direction: "vertical";
  items: StepItem[];
  spacingBetweenSteps?: number;
};

const Steps = ({ items, spacingBetweenSteps = 12 }: StepsProps) => {
  return (
    <Flex column>
      {items.map((item, index) => (
        <StageContainer key={index} data-step-index={index}>
          {index !== items.length - 1 && <Line />}
          <IconContainer>
            <UIcon icon={item.icon} {...item.iconProps} />
          </IconContainer>
          <ContentContainer column gap="16px">
            {item.title}
            {item.content}
          </ContentContainer>
          {index !== items.length - 1 && <Spacer vertical={spacingBetweenSteps} />}
        </StageContainer>
      ))}
    </Flex>
  );
};

const StageContainer = styled.div({
  position: "relative",
});

const Line = styled.div(({ theme }) => ({
  backgroundColor: theme.colors.sysBorderPrimary,
  borderRadius: "1px",
  width: "2px",
  height: "calc(100% - 32px)", // icon container height + margin
  position: "absolute",
  bottom: "0",
  left: "7px", // container width / 2 - line / 2
}));

const IconContainer = styled.div({
  float: "left",
  marginTop: "8px",
  marginBottom: "8px",
  marginLeft: 0,
  marginRight: "12px",
  height: "16px",
  width: "16px",
});

const ContentContainer = styled(Flex)({
  paddingTop: "4px",
});

export default Steps;
